
import { defineComponent, PropType } from "vue";
import { mdiReload } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import {
  ColumnConfig,
  isSlotColumnConfig,
  isPropertyColumnConfig,
} from "./table-configuration";

const PropsDef = {
  elementsKey: String,
  columnsConfig: {
    type: Object as PropType<ColumnConfig[]>,
    required: true,
  },
  rowClassesFn: {
    type: Function as PropType<(row: unknown) => string[]>,
    default: () => (): string[] => [],
  },
  tableClasses: {
    type: Array,
    default: (): string[] => [
      "is-narrow",
      "is-striped",
      "is-hoverable",
      "is-fullwidth",
    ],
  },
  elements: {
    type: Array as PropType<unknown[]>,
    default: (): unknown[] => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
};
export default defineComponent({
  name: "CustomTable",
  props: PropsDef,
  data() {
    return {
      mdiReload,
    };
  },
  methods: {
    isSlotColumnConfig,
    isPropertyColumnConfig,
    rowClasses(row: unknown): string[] {
      return this.rowClassesFn(row);
    },
  },
  components: {
    SvgIcon,
  },
});
export { PropsDef };
